import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { Profile } from '../../lib/profile';
import { useAuth } from '../../contexts/AuthContext';
import { ServerList } from '../layout/ServerList';
import { ProfileNav } from './ProfileNav';
import { ProfilePage } from './ProfilePage';

export function PublicProfile() {
  const { username } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (username) {
      loadProfile();
    }
  }, [username]);

  const loadProfile = async () => {
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('username', username)
        .single();

      if (error) throw error;
      setProfile(data);
    } catch (error) {
      console.error('Error loading profile:', error);
      setError('Profil nicht gefunden');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex bg-background-primary min-h-screen">
        {user && <ServerList />}
        <div className="flex-1 flex items-center justify-center">
          <div className="text-text-secondary">Laden...</div>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="flex bg-background-primary min-h-screen">
        {user && <ServerList />}
        <div className="flex-1 flex flex-col items-center justify-center p-4">
          <div className="text-text-primary text-xl mb-4">Profil nicht gefunden</div>
          <Link 
            to={user ? "/app/chat" : "/auth"}
            className="text-accent-primary hover:text-accent-hover"
          >
            {user ? "Zurück zum Chat" : "Zurück zur Startseite"}
          </Link>
        </div>
      </div>
    );
  }

  // If viewing own profile, redirect to profile page
  if (user && user.id === profile.id) {
    navigate('/app/profile/edit', { replace: true });
    return null;
  }

  return (
    <div className="flex bg-background-primary min-h-screen">
      {/* Show ServerList for authenticated users */}
      {user && <ServerList />}

      <div className="flex flex-1">
        {/* Show ProfileNav for authenticated users */}
        {user && <ProfileNav />}

        <div className="flex-1">
          <ProfilePage 
            profile={profile} 
            isOwnProfile={false} 
            onNavigateBack={() => navigate(-1)} 
          />
        </div>
      </div>
    </div>
  );
}